module.exports = __webpack_public_path__ + "img/antenna@2x.d0267b9e.png";